<template>
  <v-text-field
    ref="vTextField"
    v-bind="$attrs"
    @blur="$emit('blur', $event)"
    @input="valueChange($event)"
  />
</template>
<script>
export default {
  name: 'FormattedInput',
  props: {
    blurredFormat: {
      type: Function,
      default: (v) => {
        return v
      }
    }
  },
  computed: {
    isFocused () {
      return this.$refs.vTextField && this.$refs.vTextField.isFocused
    },
    lazyValue: {
      get () {
        return this.$refs.vTextField && this.$refs.vTextField.lazyValue
      },
      set (v) {
        this.$refs.vTextField.lazyValue = v
      }
    }
  },
  watch: {
    isFocused () {
      this.showValue()
    }
  },
  mounted () {
    this.showValue()
  },
  methods: {
    validate () {
      return this.$refs.vTextField && this.$refs.vTextField.validate()
    },
    showValue () {
      if (!this.isFocused) {
        this.lazyValue = this.blurredFormat(this.$refs.vTextField.value)
      } else {
        this.lazyValue = this.$refs.vTextField.value
      }
    },
    valueChange (value) {
      console.log('formattedInputValueChange', value)
      this.$emit('input', value)
    }
  }
}
</script>

